import { useQuery } from '@tanstack/react-query';
import { PaymentService } from '@/data/services';

/** Cache key of `GET /payments/subscription`, to invalidate after a payment or a team change. */
export const SUBSCRIPTION_QUERY_KEY = ['payments', 'subscription'] as const;

/** Plan, quota and usage of the signed-in account, shared by every screen that shows them. */
export function useSubscription({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: SUBSCRIPTION_QUERY_KEY,
    queryFn: PaymentService.getSubscription,
    staleTime: 60_000,
    enabled,
  });
}
